// src/ApiService/addtocartapi/addtocartapi.js
import axios from "axios";

export const addToCartApi = async (formData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/custom-add-cart/`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    console.log("Successfully added to cart (12:50 PM IST, Oct 17, 2025):", response.data);
    
    return response.data;
  } catch (error) {
    console.error("Error in addToCartApi (12:50 PM IST, Oct 17, 2025):", error.response?.data || error.message);
    throw error;
  }
};



export const SingleProductAddToCartApi = async (formData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/add-cart/`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    console.log("Successfully added to cart (12:50 PM IST, Oct 17, 2025):", response.data);
    
    return response.data;
  } catch (error) {
    console.error("Error in addToCartApi (12:50 PM IST, Oct 17, 2025):", error.response?.data || error.message);
    throw error;
  }
};
